<template lang="pug">
.map#map
  .map-container#map-container(style='width: 1280px; height: 400px;')
  .txt
    .txt_wrap
      .lt
        h3(v-if="lan == 'kr'") (주)인더케그 본사
        h3(v-else) Head Office of
          br
          | INTHEKEG Inc.
      .rg
        ul
          li
            span
              img(:src='require("../../assets/images/c_icon01.png")' alt='')
            p(v-if="lan == 'kr'")
              span.bold ADDRESS 
              | 경기도 안양시 동안구 학의로 282 8층 827호 (관양동, 금강펜테리움IT타워) 14056
            p(v-else)
              span.bold ADDRESS 
              |  827, 8F, 282, Hagui-ro, Dongan-gu, Anyang-si, Gyeonggi-do, Republic of Korea 14056
          li
            span
              img(:src='require("../../assets/images/c_icon02.png")' alt='')
            p
              span.bold TEL 
              | +82-2-31-423-3642
          li
            span
              img(:src='require("../../assets/images/c_icon03.png")' alt='')
            p
              span.bold FAX 
              | +82-31-426-4907
          li
            span
              img(:src='require("../../assets/images/c_icon04.png")' alt='')
            p
              span.bold E-MAIL 
              | info@inthekeg.com

</template>
<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      map: null,
      markerPositions: [],
      markers: [],
    };
  },
  computed: {
    ...mapGetters(['lan']),
  },
  methods: {
    initMap() {
      const container = document.getElementById('map-container');
      const options = {
        // 지도 중심 좌표
        center: new kakao.maps.LatLng(37.401097, 126.969033),
        //37.50769694739875, 127.05444169542365
        // 지도 레벨 (확대, 축소의 정도)
        level: 4,
      };
      this.map = new kakao.maps.Map(container, options);

      // 마커 생성 좌표
      var markerPosition = new kakao.maps.LatLng(37.401097, 126.969033);
      var marker = new kakao.maps.Marker({
        position: markerPosition,
      });
      marker.setMap(this.map);

      // 오버레이에 표출될 내용
      if (this.lan == 'en') {
        var iwContent =
          '<div class="roughmap_maker_label"><a href="https://map.kakao.com/link/map/경기도 안양시 동안구 학의로 282, 37.401097, 126.969033" target="_blank"><span class="roughmap_lebel_text">282, Hagui-ro, Dongan-gu, Anyang-si, Gyeonggi-do</span></a></div>';
      } else if (this.lan == 'kr') {
        var iwContent =
          '<div class="roughmap_maker_label"><a href="https://map.kakao.com/link/map/경기도 안양시 동안구 학의로 282, 37.401097, 126.969033" target="_blank"><span class="roughmap_lebel_text">경기도 안양시 동안구 학의로 282</span></a></div>';
      }
      var customOverlay = new kakao.maps.CustomOverlay({
        position: markerPosition,
        content: iwContent,
      });
      customOverlay.setMap(this.map, marker);
    },
  },
  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement('script');
      /* global kakao */
      script.onload = () => kakao.maps.load(this.initMap);
      script.src =
        '//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=7266da0f504c71a0b97051295b15e1a0';
      document.head.appendChild(script);
    }
  },
};
</script>
<style>
.roughmap_maker_label {
  top: -62px;
  left: 1px;
  position: relative;
  border: 1px solid #e5e5e5;
  border-color: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  margin: 0;
  padding: 0;
  line-height: normal;
  background: transparent;
}
.roughmap_maker_label:after {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -8px;
  width: 17px;
  height: 18px;
  margin: auto;
  background: url(//t1.daumcdn.net/localimg/localimages/07/2018/pc/map/roughmap_maker_tail.png)
    no-repeat;
  content: '';
}
.roughmap_maker_label a:active,
.roughmap_maker_label a:link,
.roughmap_maker_label a:visited {
  color: #333;
  text-decoration: none;
}
a,
a:link {
  color: #555;
  text-decoration: none;
  cursor: pointer;
}

.roughmap_maker_label .roughmap_lebel_text {
  display: block;
  position: relative;
  z-index: 10;
  padding: 6px 8px 5px;
  border-radius: 3px;
  font-weight: 600;
  font-size: 11px;
  line-height: 15px;
  background-color: #fff;
  color: #000;
}
</style>
